var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0303 12.8069C13.3347 12.8069 16.0135 10.1638 16.0135 6.90352C16.0135 3.6432 13.3347 1.00018 10.0303 1.00018C6.72597 1.00018 4.04724 3.6432 4.04724 6.90352C4.04724 10.1638 6.72597 12.8069 10.0303 12.8069Z",
    fill: "#13B76E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6284 22.8902C12.6318 22.8902 12.0743 22.1935 12.0743 22.1935C11.2532 21.1654 10.7326 19.9353 10.5689 18.6363C10.4051 17.3373 10.6045 16.0188 11.1453 14.8235L11.2196 14.6769C11.2704 14.6141 11.3023 14.5385 11.3117 14.4587C11.3211 14.3789 11.3076 14.2981 11.2728 14.2255C11.2379 14.1529 11.1831 14.0914 11.1146 14.0481C11.046 14.0047 10.9665 13.9812 10.8851 13.9802C10.589 13.9489 10.291 13.9367 9.99324 13.9435C7.80784 13.9509 5.69777 14.7323 4.04718 16.1455C2.39659 17.5587 1.31524 19.5098 1 21.6435C1 22.0835 1.14865 22.9269 2.56081 22.9269H11.4426C11.5024 22.9058 11.565 22.8934 11.6284 22.8902Z",
    fill: "#13B76E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.705,
    cy: 17.7752,
    rx: 5.295,
    ry: 5.225,
    fill: "#13B76E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.831 17.1946C17.0732 17.0307 16.8296 16.8627 16.8296 16.5988C16.8296 16.296 17.165 16.0835 17.7309 16.0835C18.3251 16.0835 18.5454 16.3196 18.5654 16.6668H19.3032C19.2815 16.1877 18.9293 15.7516 18.2316 15.6085V15.0002H17.2301V15.6002C16.5825 15.7182 16.0618 16.0655 16.0618 16.603C16.0618 17.2446 16.701 17.5641 17.6307 17.7502C18.467 17.9168 18.6322 18.1599 18.6322 18.421C18.6322 18.6113 18.4703 18.9169 17.7309 18.9169C17.0432 18.9169 16.7711 18.6599 16.7361 18.3335H16C16.0417 18.9418 16.5875 19.2821 17.2301 19.3974V20.0002H18.2316V19.403C18.8809 19.2988 19.4 18.9863 19.4 18.4155C19.4 17.6293 18.5888 17.3599 17.831 17.1946Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesPerson);
export default __webpack_public_path__ + "static/media/sales-person.f8b02b51f45627b34625224264f1162f.svg";
export { ForwardRef as ReactComponent };